<script>
import {
  BModal, BForm, BFormInput, BFormGroup, BTable, BFormCheckbox,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import axios from '@/libs/axios'
import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BTable,
    BFormCheckbox,
    VSelect,
  },
  model: {
    prop: 'blankGrupoData',
    event: 'input',
  },
  props: {
    blankGrupoData: {
      type: Object,
      default: () => ({
        id: null,
        grupousuario: '',
        abilities: [],
      }),
    },
  },
  data() {
    return {
      formData: {
        grupousuario: '',
        abilities: [],
      },
      fields: [
        {
          key: 'id', label: '#', sortable: true,
        },
        { key: 'subject', label: 'Fução' },
        { key: 'action', label: 'Ações' },
        { key: 'ability', label: 'Ativar' },
      ],
      items: [
        {
          id: 1,
          ability: 'Cliente B2B',
          created: true,
          updated: false,
          read: true,
        },
      ],
    }
  },
  watch: {
    blankGrupoData: {
      handler(newValue, oldValue) {
        if (newValue.id !== oldValue.id) {
          this.items.map(item => {
            if (newValue.abilities.find(ability => ability === item.id)) {
              item.checked = true
            }
            return item
          })
        }
      },
      deep: true,
    },
    items: {
      handler(newValue) {
        this.$emit('input', {
          ...this.blankGrupoData,
          abilities: newValue.filter(ab => ab.checked).map(i => i.id),
        })
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters('app-adm-grupousuario', ['getUGrupos']),
    labelBtnModal() {
      return this.blankGrupoData.id !== null ? 'Atualizar' : 'Cadastrar'
    },
  },
  async mounted() {
    await store.dispatch('app-adm-grupousuario/fetchUGrupos')
    await axios.get('/ability')
      .then(response => {
        this.items = response.data.abilities.map(ability => ({
          ...ability,
          checked: false,
        })).sort((a, b) => a.action - b.action)
      })
  },
  methods: {
    resetBlacnkGrupoData() {
      this.items.map(item => {
        item.checked = false
        return item
      })
      this.$emit('input', {
        id: null,
        grupousuario: '',
        abilities: [],
      })
    },
    resolveAbilityAction(ability) {
      if (ability === 'update') return 'Atualizar'
      if (ability === 'manage') return 'Gerenciar'
      if (ability === 'delete') return 'Deletar'
      if (ability === 'create') return 'Criar'
      if (ability === 'read') return 'Ver'
      return ability
    },

    resolveAbiliteSubject(ability) {
      if (ability === 'all') return 'Tudo'
      if (ability === 'ACL') return 'Permissões'
      return ability
    },
    onChangeAbility(item) {
      this.$emit('input', {
        ...this.blankGrupoData,
        abilities: this.items.filter(ab => ab.checked).map(i => i.id),
      })
      this.items.map(i => {
        if (i.id === item.id) {
          i.checked = !i.checked
        }
        return i
      })
    },
    handleSubmit() {
      if (this.blankGrupoData.id === null) {
        store.dispatch('app-adm-grupousuario/addGrupoUsuario', {
          ...this.blankGrupoData,
        })
          .then(() => {
            this.$emit('refetch-data')
          })
        return
      }

      store.dispatch('app-adm-grupousuario/updatedGrupoUsuario', {
        ...this.blankGrupoData,
      })
        .then(() => {
          this.$emit('refetch-data')
        })
      this.resetBlacnkGrupoData()
    },
  },
}
</script>

<template>
  <!-- modal login-->
  <b-modal
    id="modal-add-grupo"
    cancel-variant="outline-secondary"
    :ok-title="labelBtnModal"
    cancel-title="Cancelar"
    centered
    size="lg"
    :title="`${labelBtnModal} Grupo`"
    @ok="handleSubmit"
    @close="resetBlacnkGrupoData($event)"
    @cancel="resetBlacnkGrupoData($event)"
  >
    <b-form>
      <b-form-group>
        <label for="nome_grupo">Nome:</label>
        <b-form-input
          id="nome_grupo"
          v-model="blankGrupoData.grupousuario"
          type="text"
          name="nome_grupo"
          placeholder="Nome do grupo"
        />
      </b-form-group>
      <div class="container">
        <h3 class="py-2">
          Habilidade
        </h3>
        <div class="row">
          <div
            v-for="row in items"
            :key="row.id"
            class="col-4 d-flex mb-1"
          >
            <b-form-checkbox
              :id="`${row.id}`"
              :checked="row.checked"
              @change="onChangeAbility(row)"
            />
            <label
              :for="row.id"
              class="text-bold"
            >{{ `${resolveAbilityAction(row.action)} -> ${resolveAbiliteSubject(row.subject)}` }}</label>
          </div>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<style scoped>
.form-add-grupo__table .vs__deselect {
  fill: white;
}

</style>
